var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fadeBg"}},[_c('responsive-image',{staticClass:"absolute w-full h-full object-cover",attrs:{"image":{ srcset:_vm.srcset, url:_vm.src },"fallback-image":_vm.fallbackImage,"alt":_vm.alt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }